const bumpDataSelectTarget = 'bump-select-target';
const bumpTimeSelect = `select[data-${bumpDataSelectTarget}]`;

function bindSelectChangeHandler() {
  $(document).on('change', bumpTimeSelect, (e) => {
    showOnlySelected(e.target);
  });
}

function showOnlySelected(select) {
  const $select = $(select);

  const viewTarget = $($select.data(bumpDataSelectTarget));
  viewTarget.hide();

  const selected = $select.val();
  viewTarget.filter(`[data-time-period=${selected}]`).show();
}

function init() {
  bindSelectChangeHandler();
  $(bumpTimeSelect).each((index, el) => {
    showOnlySelected(el);
  });
}

export default {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/bump/shop_stats.js